//site users
export type UserRoles = "admin" | "manager" | "cashier" | "none";

export enum UserRolesEnum {
  admin = "admin",
  cashier = "cashier",
  manager = "manager",
  none = "none",
}

export enum AppFeature {
  VEHICLE_SALE = "vehicle_sale",
  SHOP_SALE = "shop_sale",
  PAYMENT_PROCCESS = "payment_proccess",
  PAYMENT_HISTORY = "payment_history",
  MANAGE_CUSTOMERS = "manage_customers",
  REMITTANCE = "remittance",
  REPORT_BY_CUSTOMER = "report_by_customer",
  REPORT_BY_DATE = "report_by_date",
  REPORT_BY_INQUERY = "report_by_inquery",
  REPORT_BY_REMITTANCE = "report_by_remittance",
  SYSTEM_LOGS = "system_logs",
  REPORT_BY_SALES_PERSON = "report_by_sales_person",
  REPORT_BIKE_THREEWHEEL = "report_bike_threewheel",
  CUSTOM_REPORTS = "custom_reports",
  AI_AGENT = "ai_agent",
}
export interface UserType {
  userId: any;
  username: string;
  userRole: UserRoles;
}

export enum ProductSearchType {
  ALL_PRODUCTS = "ALL_PRODUCTS",
}

export type PaymentType = "slip" | "po" | "remittance" | "gate_pass";
export enum PaymentTypeEnum {
  SLIP = "slip",
  PO = "po",
  REMITTANCE = "remittance",
  GATE_PASS = "gate_pass",
}